import apiHistorySerial from '@/api/vo/historySerial';

const defaultState = () => ({
	listSerialMembership: [],
	serialMembershipPagination: '',
	listSerialRegistration: [],
	serialRegistrationPagination: '',
});

const state = defaultState();

const getters = {

};

const mutations = {

	setSerialMembership(state, data) {
		state.listSerialMembership = data.data;
		state.serialMembershipPagination = data.pagination;
	},
	setSerialRegistration(state, data) {
		state.listSerialRegistration = data.data;
		state.serialRegistrationPagination = data.pagination;
	},
};

const actions = {
	getHistoryTransferMembership({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiHistorySerial.getHistoryTransferMembership(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSerialMembership', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSerialMembership', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryTransferActivation({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiHistorySerial.getHistoryTransferActivation(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSerialRegistration', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSerialRegistration', { data: [], pagination: {} });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};